const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';

const getAuthHeaders = () => {
  const token = localStorage.getItem('adminToken') || sessionStorage.getItem('adminToken');
  return {
    'Authorization': token ? `Bearer ${token}` : '',
    'Content-Type': 'application/json'
  };
};

export const listLatestUpdates = async (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  const response = await fetch(`${API_BASE_URL}/api/v1/admin/latest-updates${queryString ? `?${queryString}` : ''}`, {
    headers: getAuthHeaders()
  });
  
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.message || 'Failed to fetch updates');
  }
  
  const result = await response.json();
  return result.data || [];
};

export const getLatestUpdateById = async (id) => {
  const response = await fetch(`${API_BASE_URL}/api/v1/admin/latest-updates/${id}`, {
    headers: getAuthHeaders()
  });
  
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.message || 'Failed to fetch update');
  }
  
  const result = await response.json();
  return result.data;
};

export const createLatestUpdate = async (data, pdfFile = null) => {
  let body;
  let headers = getAuthHeaders();
  
  if (pdfFile) {
    // Use FormData for file upload
    const formData = new FormData();
    Object.keys(data).forEach(key => {
      formData.append(key, data[key]);
    });
    formData.append('pdf', pdfFile);
    body = formData;
    // Remove Content-Type header to let browser set it with boundary
    headers = { 'Authorization': headers.Authorization };
  } else {
    body = JSON.stringify(data);
  }
  
  const response = await fetch(`${API_BASE_URL}/api/v1/admin/latest-updates`, {
    method: 'POST',
    headers,
    body
  });
  
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.message || 'Failed to create update');
  }
  
  const result = await response.json();
  return result.data;
};

export const updateLatestUpdate = async (id, data, pdfFile = null) => {
  let body;
  let headers = getAuthHeaders();
  
  if (pdfFile) {
    // Use FormData for file upload
    const formData = new FormData();
    Object.keys(data).forEach(key => {
      formData.append(key, data[key]);
    });
    formData.append('pdf', pdfFile);
    body = formData;
    // Remove Content-Type header to let browser set it with boundary
    headers = { 'Authorization': headers.Authorization };
  } else {
    body = JSON.stringify(data);
  }
  
  const response = await fetch(`${API_BASE_URL}/api/v1/admin/latest-updates/${id}`, {
    method: 'PATCH',
    headers,
    body
  });
  
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.message || 'Failed to update update');
  }
  
  const result = await response.json();
  return result.data;
};

export const toggleLatestUpdate = async (id, isActive) => {
  const response = await fetch(`${API_BASE_URL}/api/v1/admin/latest-updates/${id}/toggle`, {
    method: 'PATCH',
    headers: getAuthHeaders(),
    body: JSON.stringify({ is_active: isActive })
  });
  
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.message || 'Failed to toggle update');
  }
  
  const result = await response.json();
  return result.data;
};

export const toggleFeatured = async (id, isFeatured) => {
  const response = await fetch(`${API_BASE_URL}/api/v1/admin/latest-updates/${id}/featured`, {
    method: 'PATCH',
    headers: getAuthHeaders(),
    body: JSON.stringify({ is_featured: isFeatured })
  });
  
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.message || 'Failed to toggle featured');
  }
  
  const result = await response.json();
  return result.data;
};

export const deleteLatestUpdate = async (id) => {
  const response = await fetch(`${API_BASE_URL}/api/v1/admin/latest-updates/${id}`, {
    method: 'DELETE',
    headers: getAuthHeaders()
  });
  
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.message || 'Failed to delete update');
  }
  
  const result = await response.json();
  return result.data;
};

export const normalizeLatestUpdate = (raw) => {
  if (!raw) return null;
  return {
    id: raw.id,
    title: raw.title,
    slug: raw.slug,
    type: raw.type || 'text',
    content: raw.content,
    pdf_url: raw.pdf_url,
    pdf_file_name: raw.pdf_file_name,
    pdf_size: raw.pdf_size,
    is_featured: raw.is_featured || false,
    display_order: raw.display_order || 0,
    is_active: raw.is_active !== false,
    published_at: raw.published_at,
    created_at: raw.created_at,
    updated_at: raw.updated_at
  };
};
